import {AUTH_REQUEST, AUTH_LOGOUT} from "./actions";
import AuthService from "@/services/auth.service"
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import $bus from "@/events/global.event.bus"
import * as GlobalBusEvents from "@/events/auth"

export default {
    state: {
        token: JSON.parse(localStorage.getItem("token"))
    },
    getters: {
        accessToken: (state) => {
            if (state.token)
                return state.token.access_token
            return null
        },
        isTokenOk: (state) => {
            if (state.token) {
                const now = new Date();
                const tokenIssuedOn = new Date(state.token.issued);
                const diff = now - tokenIssuedOn;

                // one day diff allowed
                if (diff < 6 * 24 * 60 * 60 * 1000)
                    return true
            }
            return false;
        }
    },
    mutations: {
        updateToken(state, token) {
            state.token = token;
        }
    },
    actions: {
        [AUTH_REQUEST]: ({commit, dispatch}, {username, password}) => {
            dispatch(LAYOUT_LOADING_START)

            AuthService.auth({username: username, password: password})
                .then(response => {
                    let token = response.data;
                    token.issued = new Date().toISOString();

                    localStorage.setItem("token", JSON.stringify(token))
                    commit("updateToken", token)

                    $bus.$emit(GlobalBusEvents.AUTH_SUCCESS)
                })
                .catch(() => {
                    $bus.$emit(GlobalBusEvents.AUTH_FAILED)
                })
                .finally(() => {
                    dispatch(LAYOUT_LOADING_STOP)
                })
        },
        [AUTH_LOGOUT]: ({commit}) => {
            localStorage.removeItem("token")
            commit("updateToken", null)

            $bus.$emit(GlobalBusEvents.AUTH_LOGOUT)
        }
    }
}